import * as WebViewActionTypes from './action-types.constants';
import * as WebViewActions from './web-view.actions';

/**
 * Implements Medscape's API for Omniture beacon tracking
 *
 * @param   {String} value      (required) Syntax: `${mmodule}` or `${mmodule}_${mlink}`
 * @param   {HTMLElement} el    (optional) Tracks Element's text
 * @param   {Boolean} check     (optional) 
 *                              - true (default): checks tracking on the next Page View
 *                              - false: disables checking. eg: (URL used for fetching content that renders on the current page view)
 */

function handleOmnitureTracking(value = "", el, check = true) {
    const { wmdTrack, wmdPageLink } = window;
    //console.log("[WebView Middleware] handleOmnitureTracking:", value, "\n", el, "\ncheck:", check);
    if (check === true && el != null && el.tagName == "A" && el.getAttribute("href") != null && el.getAttribute("href").trim() !== "" && el.getAttribute("href").startsWith("#") === false) {

        const hostname = el.hostname;
        if (hostname.includes(".medscape.")) {
            //console.log("[trackLink] Internal Link",linkEl)
            wmdTrack(value, el);
        } else {
            //console.log("[trackLink] External Link",linkEl);
            wmdPageLink(value, el);
        }
    } else if (el != null) {
        wmdPageLink(value, el);
    } else {
        //console.log("[trackLink] External Link",linkEl);
        wmdPageLink(value);
    }
}

/**
 * Implements Medscape's API for CP Post reequests
 *
 * @param   {Oject} data      JSON Data
 *
 */
function handlePostCP(data) {
    //console.log("[WebViewMiddleware] handlePostCP:",data);
    window.postCp(data);
}

/**
 * Implements Medscape's API for CP Post reequests
 *
 * @param   {Oject} location      Web API's Location Interface
 *
 */
function handlePageView(location) {
    //console.log("[WebViewMiddleware] handlePageView:", location);
    //let { s_md, wmdPageView } = window;
    let pageName = `${location.host}${location.pathname}`;
    //console.log("[WebViewMiddleware] PageView:", pageName);
    window.wmdPageview(pageName);
}




function handleReady(storeAPI) {
    let debounce_resize = null;
    function onResize(e) {
        storeAPI.dispatch(WebViewActions.resize(e));
    }
    function handleResize(e) {

        window.clearTimeout(debounce_resize);
        debounce_resize = window.setTimeout(
            function() {
                onResize(e);
            },
            250
        )
    }


    window.addEventListener('resize', handleResize, true);
    window.addEventListener('orientationchange', onResize, true);

}

const WebViewMiddleware = storeAPI => next => action => {
    // Do something in here, when each action is dispatched
    //const state = storeAPI.getState();
    //console.log('[WebViewMiddleware] current state', state)
    //console.log('[WebViewMiddleware] dispatching', action.type);

    let result = next(action);
    //const nextState = storeAPI.getState();
    //console.log('[WebViewMiddleware] next state', nextState);
    switch (action.type) {
        case WebViewActionTypes.READY:
            handleReady(storeAPI);
            break;
        case WebViewActionTypes.OMNITURE_TRACKING:
            //loadExternalResources(storeAPI);
            handleOmnitureTracking(action.value, action.el, action.checkMedscapePageLink);
            break;
        case WebViewActionTypes.POST_CP:
            handlePostCP(action.data);
            break;
        case WebViewActionTypes.TRACK_PAGEVIEW:
            handlePageView(action.location)
            break;
    }

    return result
}

export default WebViewMiddleware;